import React, { useEffect } from "react";

export const Toast = ({ message, type = "success", onClose }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose(); // auto-close after 5 seconds
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  if (!message) return null;

  return (
    <>
      <style>{`
        .toast-container {
          position: fixed;
          bottom: 30px;
          right: 30px;
          padding: 12px 20px;
          border-radius: 8px;
          color: white;
          font-weight: 500;
          z-index: 99999999;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          animation: fadeIn 0.08s ease-out;
          gap: 12px;
          max-width: 300px;
        }

        .toast-success {
          background-color: #10b981;
        }

        .toast-error {
          background-color: #ef4444;
        }

        .toast-close {
          background: transparent;
          border: none;
          color: white;
          font-size: 1.2rem;
          cursor: pointer;
          margin-left: auto;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <div className={`toast-container toast-${type}`}>
        <span>{type === "success" ? "✅" : "❌"} {message}</span>
        <button className="toast-close" onClick={onClose}>×</button>
      </div>
    </>
  );
};
